module.exports = __webpack_public_path__ + "img/Tina Haibodi.5edccc6e.jpg";